module.exports = "/_next/static/images/weibo-4a9a0f06.png";